module.exports = __webpack_public_path__ + "static/media/chatbot.e109fe36.png";